import React from 'react';
import NavLink from 'react-router-dom/NavLink';
import withRouter from 'react-router/withRouter'

import {observer} from 'mobx-react';

import Logo from '../../../elements/brand/Logo'
import Identities from '../../../elements/Identities'

import styles from './Footer.sass';
import uiState, {StatusConstants} from "../../../core/uiState";


export default withRouter(observer(() => uiState.loader.status === StatusConstants.READY && <footer className={styles.wrapper}>
        <div className={styles.skewer} />
        <div className={styles.root}>
            <div className="larger grid">
                <form className={styles.newsletter} method="post" action="//gamedevjs.us3.list-manage.com/subscribe/post?u=4ad274b490aa6da8c2d29b775&id=bacab0c8ca">
                    <span />
                    <h6>Newsletter<a href="http://gamedevjsweekly.com">Gamedev.js Weekly</a></h6>
                    <div>
                        <input type="hidden" name="b_4ad274b490aa6da8c2d29b775_bacab0c8ca" value="" />
                        <input type="email" name="EMAIL" placeholder="twoj@email.com" required />
                        <button className="alt button"><i className="check icon" /></button>
                    </div>
                </form>

                <Logo Element={NavLink} inverted exact to="/" className={styles.logo} />

                <nav className={styles.nav}>
                    <NavLink to="/wydarzenia">Wydarzenia</NavLink>
                    <NavLink to="/prelegenci">Prelegenci</NavLink>
                    <NavLink to="/partnerzy">Partnerzy</NavLink>
                    <NavLink to="/o-nas">O nas</NavLink>
                    <NavLink to="/kontakt">Kontakt</NavLink>
                </nav>
                <Identities className={styles.identities}>
                    {[
                        "https://join.slack.com/t/gamedevjs/shared_invite/enQtMjY4OTQ5MTQxNDQ1LTkzMzBiYjhhYmJiMGNhOTg1YjJlNzYyNDdiNGVhYzIxNjJhNDIyNWZiYTU3OWYzYzVjZDZlODY2NTJmNGZjOTY",
                        "https://twitter.com/gamedevjs",
                        "https://www.facebook.com/gamedevjs",
                        "https://www.youtube.com/c/gamedevjs"
                    ]}
                </Identities>
                <div className={styles.ps}>Stitched together with a <b>whole lotta</b> <i className="icon heart" /></div>
                <div className={styles.background} />
            </div>
        </div>
    </footer>
));


// WEBPACK FOOTER //
// ./src/layouts/Default/Footer/Footer.js